import React, { Component } from "react";
import { Panel } from "react-bootstrap";
import { connect } from "react-redux";
import { Form, Control, Field, Errors, actions } from "react-redux-form";
import { Link } from "react-router-dom";
import ArrowButton from "../../common/button-arrow";
import { login as loginAction } from "../../../actions/login";
import ErrorMessages from "../error-messages";
import PasswordMaskInput from "../../common/form/elements/password-mask-input";
import CookieConsent from "../../cookie-consent/cookie-consent";
import "./login-form.css";

class LoginForm extends Component {
  handleSubmit(payLoad) {
    const { dispatch } = this.props;
    dispatch(actions.submit("deep.login", loginAction(payLoad, dispatch)));
  }

  render() {
    return (
      <Form model="deep.login" onSubmit={(login) => this.handleSubmit(login)}>
        <CookieConsent />
        <Errors
          className="errors"
          model="deep.login"
          component={ErrorMessages}
        />
        <Panel
          header={<h1 className="text-uppercase">Login</h1>}
          footer={
            <ArrowButton arrow={false} className="btn-block">
              Login
            </ArrowButton>
          }
          className="login p-3 mb-5 bg-white rounded"
          bsStyle="primary"
        >
          <Field model=".login" className="form-group">
            <label className="control-label">E-mail or mobile:</label>
            <input type="text" className="form-control" />
          </Field>

          <div className="form-group">
            <label className="control-label">Password:</label>
            <Control model=".password" component={PasswordMaskInput} />
          </div>
          <div className="form-group">
            <div className="checkbox">
              <label>
                <input type="checkbox" /> Remember me
              </label>
            </div>
          </div>
          <div id="forgottenPasswordLabel">
            Forgotten Password? <Link to={"/reset-password"}>Click here</Link>
          </div>
        </Panel>
      </Form>
    );
  }
}

function mapStateToProps(state) {
  return { login: state.deep.login };
}

export default connect(mapStateToProps)(LoginForm);



// WEBPACK FOOTER //
// ./src/components/login/login-form/index.jsx